import React from 'react';

import PauseController from '../../assets/pause-controller.svg?react';
import PlayController from '../../assets/play-controller.svg?react';
import StopController from '../../assets/stop-controller.svg?react';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

import styles from './Controls.module.css'
import { formatTime } from '../../services/formatFunctions';
import { IconButton } from '@mui/material';
import { useParams } from 'react-router-dom';

interface ControlsProps {
  playerRef: React.RefObject<HTMLMediaElement | null>;
  setIsPlaying: (playing: boolean) => void;
  totalDuration: number;
  progress: number;
  toggleFullScreen?: () => void;
  isFullScreen?: boolean;
}

const Controls: React.FC<ControlsProps> = ({playerRef, setIsPlaying, totalDuration, progress, toggleFullScreen, isFullScreen}) => {
    const {slug} = useParams()


    return (
        // notranslate: transport controls — Google Translate's DOM edits break
        // React reconciliation on iOS (Sentry CUSTOM-APP-D).
        <div className={`${styles.playerControls} notranslate`} translate='no'>
            <div className={styles.controlBtns}>
                <button aria-label='play' onClick={() => setIsPlaying(true)}>
                    <PlayController color='currentColor' width={20} height={20}/>
                </button>
                <button aria-label='pause' onClick={() => setIsPlaying(false)}>
                    <PauseController color='currentColor' width={20} height={20}/>
                </button>
                <button aria-label='stop' onClick={() => setIsPlaying(false)}>
                    <StopController color='currentColor' width={20} height={20}/>
                </button>
            </div>
            <p className="duration">
                {formatTime(progress)}/{formatTime(totalDuration)}
            </p>
            {toggleFullScreen && 
            <IconButton sx={{color : 'inherit'}} onClick={toggleFullScreen} aria-label={isFullScreen? 'exit full screen' : 'enter full screen'}>
            {isFullScreen ? <FullscreenExitIcon fontSize="large" /> : <FullscreenIcon fontSize="large" />}

            </IconButton>}
        </div>
    );
};

export default Controls;
